import styled from 'styled-components';

import { EmptyStateView } from '../../../components/EmptyStateView';

export const StyledSalesforceActivityTitle = styled.span`
  display: flex;
  align-items: center;
  gap: 8px;
`;

export const StyledEmptyStateView = styled(EmptyStateView)`
  width: 100%;
  margin-top: 20px;
  margin-bottom: 44px;
`;
